export var DealersOrderBy = {
  createdAt: 'CREATED_AT',
  'managers.modifiedBy.id': 'CREATOR_ID',
  email: 'EMAIL',
  level: ' LEVEL',
  'managers.createdBy.id': 'MODIFIER_ID',
  storePhone: ' PHONE',
  realname: 'REALNAME',
  status: 'STATUS',
  updatedAt: 'UPDATED_AT',
  'user.username': 'USERNAME'
};